<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-07 16:08:23
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-07 18:08:44
 * @FilePath: \partner.chaoyongtuan.com\src\views\sampleOrder\list\components\refuseApply.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog width="400px" title="拒绝申请" :before-close="beforeClose" :visible.sync="visible" :append-to-body="true" :close-on-click-modal="false">
		<el-input type="textarea" :rows="3" placeholder="请输入拒绝申请" v-model="refuseReason" />
		<div slot="footer">
			<el-button @click="beforeClose">取消</el-button>
			<el-button type="primary" @click="confirm">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { sampleAuditRefuse, batchSampleAuditRefuse } from '@/api/sampleOrder';
export default {
	data() {
		return {
			visible: false,
			refuseReason: '',
			params: {},
			refuseType: 'single',
		};
	},
	methods: {
		show(params, type) {
			this.refuseType = type;
			this.params = params;
			this.visible = true;
		},
		async confirm() {
			const { refuseReason, refuseType, params } = this;
			if (refuseType === 'batch') {
				const { fail = [], success = [] } = await batchSampleAuditRefuse({ ...params, refuseReason });
				this.$modal({
					title: '提示',
					contentTitle: `操作成功 ${success.length} 条，失败 ${fail.length} 条`,
					size: 'small',
					btns: [
						{
							type: 'primary',
							text: '我知道了',
							key: 'confirm',
						},
					],
				}).then(res => {
					if (res.key == 'confirm') {
						res.done();
					} else {
						res.done();
					}
				});
				this.$emit('refresh');
				this.beforeClose();
			} else {
				await sampleAuditRefuse({ ...params, refuseReason });
				this.$message.success('操作成功！');
				this.$emit('refresh');
				this.beforeClose();
			}
		},
		beforeClose() {
			this.params = {};
			this.refuseType = 'single';
			this.refuseReason = '';
			this.visible = false;
		},
	},
};
</script>
